import { render, staticRenderFns } from "./type3.vue?vue&type=template&id=703a73f4&scoped=true"
import script from "./type3.vue?vue&type=script&lang=js"
export * from "./type3.vue?vue&type=script&lang=js"
import style0 from "./type3.vue?vue&type=style&index=0&id=703a73f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703a73f4",
  null
  
)

export default component.exports